module.exports = __webpack_public_path__ + "static/media/2DGACM15.6fec7369.jpg";